/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Reorder Icon component.
 */
export const SortUpIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.1912 6.38237L7.51969 3L4 6.38237" stroke="#4F4F4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.59204 14V4.14197" stroke="#4F4F4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
